import { InningState } from "mannequin/src/types/tracking/mannequin/game-event";
import { Context } from "../context";
import { CameraMode } from "../camera/controller";

interface VideoBoardManifest {
  [key: `${number}-middle`]: string;
  [key: `${number}-end`]: string;
}

const DEFAULT_VIDEO_BOARD_MANIFEST: VideoBoardManifest = {
  "1-middle": "/videos/ballpark/mc_sutc.mp4",
  "1-end": "/videos/ballpark/mlb_app.mp4",
  "2-middle": "/videos/ballpark/mc_tap.mp4",
  "2-end": "/videos/ballpark/mlb_vote.mp4",
  "3-middle": "/videos/ballpark/mascot1.mp4",
  "3-end": "/videos/ballpark/mc_sutc.mp4",
  "4-middle": "/videos/ballpark/mlb_app.mp4",
  "4-end": "/videos/ballpark/mlb_vote.mp4",
  "5-middle": "/videos/ballpark/mc_tap.mp4",
  "5-end": "/videos/ballpark/hat1.mp4",
  "6-middle": "/videos/ballpark/mc_sutc.mp4",
  "6-end": "/videos/ballpark/mlb_app.mp4",
  "7-middle": "/videos/ballpark/mc_tap.mp4",
  "7-end": "/videos/ballpark/mlb_vote.mp4",
  "8-middle": "/videos/ballpark/mascot3.mp4",
  "8-end": "/videos/ballpark/mc_sutc.mp4",
  "9-middle": "/videos/ballpark/mc_tap.mp4",
  "9-end": "/videos/ballpark/hat3.mp4",
};

export class VideoBoardManager {
  pollId?: NodeJS.Timer;
  previousInning?: { inningNumber: number; inningState: InningState };
  context?: Context;
  videoBoardManifest: VideoBoardManifest = DEFAULT_VIDEO_BOARD_MANIFEST;

  init(context: Context) {
    this.context = context;

    // if we aren't looking at a specific play, don't listen for inning
    // change events to trigger a video to the board
    if (this.context.options.playbackMode !== "PLAY") {
      fetch(`${this.context.options.assetBase}/videos/ballpark/manifest.json`)
        .then((resp) => resp.json())
        .then((manifest) => {
          this.videoBoardManifest = manifest;
        })
        .catch((e) => {
          console.error("error loading video board manifest", e);
        });

      this.pollId = setInterval(() => {
        const inning = context.gameState.getInning();
        const currentInningState = inning?.inningState;
        const previousInningState = this.previousInning?.inningState;
        if (
          (previousInningState === "bottom" || previousInningState === "top") &&
          (currentInningState === "middle" || currentInningState === "end")
        ) {
          if (inning) {
            this.handleInningChange(inning.inningNumber, currentInningState);
          }
        }
        this.previousInning = inning;
      }, 5000);
    }
  }

  getVideo(inning: number, half: "middle" | "end"): string {
    const modInning = ((inning - 1) % 9) + 1;
    const key = `${modInning}-${half}`;
    const path = this.videoBoardManifest[key] || "/videos/ballpark/mc_sutc.mp4";

    return `${this.context?.options.assetBase}${path}`;
  }

  teardown() {
    if (this.pollId) {
      clearInterval(this.pollId);
    }
  }

  handleInningChange(inning: number, half: "middle" | "end") {
    if (this.context && this.context.cameraController) {
      const videoUrl = this.getVideo(inning, half);

      // Play the video
      this.context.world?.stadium.jumbotron.playVideo(videoUrl, () => {
        // When the video ends, come back to the strikezone camera
        this.context?.cameraController?.setMode(CameraMode.STRIKEZONE);
      });

      // move the camera to the Jumbotron
      this.context.cameraController.setMode(CameraMode.JUMBOTRON);
    }
  }
}
